import { Title, Meta, Link } from "@solidjs/meta";
import { A } from "@solidjs/router";
import LinkButton from "@/components/link-button";
import {
  CpuIcon, BookOpenIcon, PlusIcon, TerminalIcon,
  GitBranchIcon, FunctionSquareIcon, DatabaseIcon, BinaryIcon,
  ArrowLeftRightIcon, ScaleIcon, RouteIcon, ArrowRightIcon, Grid3x3Icon, FlagIcon, CoffeeIcon,
} from "lucide-solid";
import { SUPPORT_URL } from "@/lib/support";

export const BASE = "https://lyszt.net";

export const RES_ICONS = { Cpu: CpuIcon };

export const LESSON_ICONS = {
  BookOpen: BookOpenIcon, Plus: PlusIcon, Terminal: TerminalIcon,
  GitBranch: GitBranchIcon, FunctionSquare: FunctionSquareIcon, Database: DatabaseIcon,
  ArrowRight: ArrowRightIcon, Grid3x3: Grid3x3Icon, Flag: FlagIcon,
};

export const CAT_ICONS = {
  Plus: PlusIcon, Binary: BinaryIcon, ArrowLeftRight: ArrowLeftRightIcon,
  Scale: ScaleIcon, Database: DatabaseIcon, GitBranch: GitBranchIcon,
  Route: RouteIcon, Terminal: TerminalIcon,
};

export const DOT = {
  emerald: "text-emerald-400", sky: "text-sky-400", violet: "text-violet-400",
  amber: "text-amber-400", rose: "text-rose-400", orange: "text-orange-400",
  teal: "text-teal-400", slate: "text-slate-400",
};

// Fixed solid colors (same in light/dark, high contrast). Not theme-relative tints.
export const BADGE = {
  emerald: "bg-emerald-600 text-white border-emerald-600", sky: "bg-sky-600 text-white border-sky-600",
  violet: "bg-violet-600 text-white border-violet-600", amber: "bg-amber-500 text-white border-amber-500",
  rose: "bg-rose-600 text-white border-rose-600", orange: "bg-orange-500 text-white border-orange-500",
  teal: "bg-teal-600 text-white border-teal-600", slate: "bg-slate-600 text-white border-slate-600",
};

// SEO head for a resource page. path includes the locale prefix, no domain.
export function Head(props) {
  const url = () => `${BASE}${props.path}`;
  const ogSrc = () => {
    const og = props.ogImage;
    return og ? (og.startsWith("http") ? og : `${BASE}/${og}`) : `${BASE}/og.png`;
  };
  return (
    <>
      <Title>{props.title}</Title>
      <Meta name="description" content={props.description} />
      <Link rel="canonical" href={url()} />
      <Meta property="og:title" content={props.title} />
      <Meta property="og:description" content={props.description} />
      <Meta property="og:type" content="article" />
      <Meta property="og:url" content={url()} />
      <Meta property="og:image" content={ogSrc()} />
      <Meta name="twitter:card" content="summary_large_image" />
      <Meta name="twitter:title" content={props.title} />
      <Meta name="twitter:description" content={props.description} />
      <Meta name="twitter:image" content={ogSrc()} />
      {props.ld && (
        // eslint-disable-next-line solid/no-innerhtml
        <script type="application/ld+json" innerHTML={JSON.stringify(props.ld)} />
      )}
    </>
  );
}

// The funnel link from a resource page into the live interactive simulator.
export function SimBacklink(props) {
  return (
    <LinkButton href={`${props.prefix}/toolkit/${props.slug}?view=full`} icon={<CpuIcon size={15} />}>
      {props.label}
    </LinkButton>
  );
}

export function SupportLink(props) {
  return (
    <LinkButton href={SUPPORT_URL} external icon={<CoffeeIcon size={15} />}>
      {props.label}
    </LinkButton>
  );
}
